import classNames from 'classnames';

import styles from './ArrowButton.module.css';

import type { ArrowProps } from '../../icons/Arrow';
import { Arrow } from '../../icons/Arrow';
import type { ButtonBaseProps } from '../ButtonBase';
import { ButtonBase } from '../ButtonBase';

export interface ArrowButtonProps extends ButtonBaseProps {
  /** The direction of the arrow. */
  direction: ArrowProps['arrowDirection'];
  /**
   * Set the style of the button
   *
   * @deprecated Set the style from the parent component.
   */
  variant?: 'default' | 'white-bg';
}

/**
 * Render an arrow icon as a button.
 *
 * @deprecated Use {@link IconButton} instead.
 * @see https://corgi-x.tfd.engineering/components/arrowbutton
 */
export function ArrowButton(props: ArrowButtonProps) {
  const {
    direction = 'up',
    className,
    variant = 'default',
    ...buttonProps
  } = props;
  return (
    <ButtonBase
      className={classNames(styles.button, className, styles[variant])}
      {...buttonProps}
    >
      <Arrow arrowDirection={direction} baseColor="Kale3" />
    </ButtonBase>
  );
}
